// components/Modals/PayoutRequestModal.jsx

import React, { useState, useEffect } from "react";
import Modal from "../../components/Elements/Modal/Modal";
import MainButton from "../../components/Elements/MainButton/MainButton";
import SecondButton from "../../components/Elements/SecondButton/SecondButton";
import MainInput from "../../components/Elements/MainInput/MainInput";
import ErrorMessage from "../../components/Elements/ErrorMessage/ErrorMessage";
import SuccessMessage from "../../components/Elements/SuccessMessage/SuccessMessage";
import AffiliationService from "../../services/AffiliationService";
import "../Profile/ProfileModals.css";

const PayoutRequestModal = ({ isOpen, onClose, walletId, maxAmount, onSuccess }) => {
  // Form fields
  const [amount, setAmount] = useState("");
  const [bankAccountNo, setBankAccountNo] = useState("");

  // UI state
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [sending, setSending] = useState(false);

  const resetState = () => {
    setAmount("");
    setBankAccountNo("");
    setError("");
    setSuccess("");
    setSending(false);
  };

  useEffect(() => {
    if (isOpen) {
      resetState();
    }
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!amount || isNaN(parseFloat(amount)) || parseFloat(amount) <= 0) {
      setError("Enter a valid payout amount");
      return;
    }

    if (!bankAccountNo.trim()) {
      setError("Bank account number is required");
      return;
    }

    // if (parseFloat(amount) > maxAmount) {
    //   setError(`Amount cannot be greater than ${maxAmount}`);
    //   return;
    // }

    try {
      setSending(true);
      console.log("Request Payout: ", walletId, parseFloat(amount), bankAccountNo.trim());
      await AffiliationService.requestWalletPayout(walletId, parseFloat(amount), bankAccountNo.trim());
      setSuccess("Payout requested successfully.");
      onSuccess?.();
    } catch (err) {
      const backendError =
        err.response?.data?.detail || err.response?.data?.error || err.message || "Payout request failed";

      setError(backendError);
    } finally {
      setSending(false);
    }
  };

  const isButtonDisabled = sending || !amount || parseFloat(amount) <= 0 || !bankAccountNo.trim();

  return (
    <Modal
      isOpen={isOpen}
      onClose={sending ? () => {} : onClose}
      title="Request Payout"
      actions={
        <>
          <SecondButton onClick={onClose} disabled={sending}>
            Cancel
          </SecondButton>
          <MainButton onClick={handleSubmit} disabled={isButtonDisabled}>
            {sending ? "Requesting..." : "Request Payout"}
          </MainButton>
        </>
      }
    >
      <form onSubmit={handleSubmit} className="profile-modal-form">
        {/* Commented out wallet ID, but kept in case you decide to show it later */}
        {/* <label>
          From wallet ID
          <MainInput
            type="text"
            value={walletId || ""}
            readOnly
            disabled={sending}
            className="profile-user-edit-input-readonly"
          />
        </label> */}

        {/* Amount */}
        <label>
          Amount
          <MainInput
            type="number"
            step="0.01"
            min="0.01"
            value={amount}
            onChange={(e) => {
              setAmount(e.target.value);
              setError("");
            }}
            disabled={sending}
            placeholder={`0.00`}
          />
        </label>

        {/* Bank account number */}
        <label>
          Bank account number
          <MainInput
            type="text"
            value={bankAccountNo}
            onChange={(e) => {
              setBankAccountNo(e.target.value);
              setError("");
            }}
            disabled={sending}
            placeholder="Enter bank account number"
          />
        </label>

        {/* Error / success messages */}
        {error && (
          <div className="profile-transfer-error-wrapper">
            <ErrorMessage message={error} onClose={() => setError("")} />
          </div>
        )}
        {success && (
          <div className="profile-transfer-success-wrapper">
            <SuccessMessage message={success} onClose={() => setSuccess("")} />
          </div>
        )}
      </form>
    </Modal>
  );
};

export default PayoutRequestModal;
